import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../../i18n";
import { RootState } from "../../../../redux/store";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { SelectedFilter } from "../../../../components/Filters/types";
import { getSecurityIPS } from "../api/securityIPSAPI";

type QueryFnType = typeof getSecurityIPS;

type UseSearchImprovementPlansOptions = {
    config?: QueryConfig<QueryFnType>;
    search?: string;
    filters?: SelectedFilter[];
};

export const useSecurityIPS = ({
    config,
    search = "",
    filters = []
}: UseSearchImprovementPlansOptions = {}) => {
    const historical = useSelector((state: RootState) => state.historical.ips);
    const onlyActive = useSelector((state: RootState) => state.filters.ips.filterByOnlyActiveRecords);

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: [
            "ips",
            historical.currentPage,
            historical.itemsPerPage,
            search,
            JSON.stringify(filters),
            onlyActive,
            i18n.language
        ],
        queryFn: () =>
            getSecurityIPS({
                pageNumber: historical.currentPage,
                pageSize: historical.itemsPerPage,
                search,
                filterByOnlyActiveRecords: onlyActive,
                 filters
            }),
    });
};